/**
 * Directional drift left gesture
 * @module gestures/effects/driftLeft
 */
import { createDriftGesture } from './driftFactory.js';
export default createDriftGesture('left');
